import styled from "styled-components"

export default styled.hr`
    background-color: ${props => props.theme.colors.TertiaryColor};
    margin-top: 5px;
    margin-bottom: 5px;
    height: 1px;
`